var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenAllCards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.648 12.398l.704.704-2.852 2.851-2.852-2.851.704-.704L11 14.047V8H4v6.047l1.648-1.649.704.704L3.5 15.953.648 13.102l.704-.704L3 14.047V7h4V0h1v7h4v7.047l1.648-1.649z",
    fill: "currentColor"
  })));
}

export default SvgOpenAllCards;